// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hamburger-icon {
  width: 2.2rem;
  height: 1.5rem;
  position: relative;
  transform: rotate(0deg);
  transition: 0.5s ease-in-out;
  cursor: pointer;
}
.hamburger-icon span {
  display: block;
  position: absolute;
  height: 5px;
  width: 100%;
  background: var(--navbar-hamburger-menu-color);
  border-radius: 9px;
  opacity: 1;
  left: 0;
  transform: rotate(0deg);
  transition: 0.25s ease-in-out;
}
.hamburger-icon span:nth-child(1) {
  top: 0;
  transform-origin: left center;
}
.hamburger-icon span:nth-child(2) {
  top: 0.65rem;
  transform-origin: left center;
}
.hamburger-icon span:nth-child(3) {
  top: 1.25rem;
  transform-origin: left center;
}
.hamburger-icon.active span:nth-child(1) {
  transform: rotate(45deg);
  top: 0;
  left: 4px;
}
.hamburger-icon.active span:nth-child(2) {
  width: 0;
  opacity: 0;
}
.hamburger-icon.active span:nth-child(3) {
  transform: rotate(-45deg);
  top: 25px;
  left: 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/Icons/Icons.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,4BAAA;EACA,eAAA;AACJ;AACI;EACI,cAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,8CAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,uBAAA;EACA,6BAAA;AACR;AACQ;EACI,MAAA;EACA,6BAAA;AACZ;AAEQ;EACI,YAAA;EACA,6BAAA;AAAZ;AAGQ;EACI,YAAA;EACA,6BAAA;AADZ;AAOY;EACI,wBAAA;EACA,MAAA;EACA,SAAA;AALhB;AAQY;EACI,QAAA;EACA,UAAA;AANhB;AASY;EACI,yBAAA;EACA,SAAA;EACA,SAAA;AAPhB","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
